import { render } from "./add_consumables_modal.vue?vue&type=template&id=409d85ee&scoped=true"
import script from "./add_consumables_modal.vue?vue&type=script&lang=js"
export * from "./add_consumables_modal.vue?vue&type=script&lang=js"

import "./add_consumables_modal.vue?vue&type=style&index=0&id=409d85ee&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409d85ee"]])

export default __exports__